import React, { useState, useEffect, useRef } from "react";
import { Pagination, Button, Form, Badge } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import axios from "axios";
import { API_BASE_URL } from "../../global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import DOMPurify from "dompurify";



const SearchResultTable = ({ entries, handlesearchdataclick, handleremovesearchclick, searchterm, tagenable, tagadddisable }) => {
    const { message, search_keywords, type, search_report_enable } = entries;
    // Get actual page numbers from the results

    const actualPages = message?.map(item => item.page_no);

    const [actualPageNumbers, setactualPageNumbers] = useState([]);  
    const [currentPage, setCurrentPage] = useState(actualPages[0]);  
    const [noteslist, setNoteslist] = useState([]);
    const [notescount, setNotesCount] = useState(0);
    const [noteInput, setNoteInput] = useState('');
    const [editIndex, setEditIndex] = useState(null);
    const [editNoteId, setEditNoteId] = useState(null);

    const [activeKey, setActiveKey] = useState([]); 

    const [tagsChanged, setTagsChanged] = useState(false);


    //tags state 
    const [tagdropdownEnable, settagdropdownEnable] = useState(false);
    const [tagsOnPage, setTagsOnPage] = useState([]);
    const [tagsogOnPage, setTagsogOnPage] = useState([]);
    const [tagslabelOnPage, setTagslabelOnPage] = useState([]);
    const [createdTags, setCreatedTags] = useState([]);
    const [tagsInput, setTagsInput] = useState('');
    const [tagscount, setTagsCount] = useState(0);
    const [currentpageTagsCount, setcurrentpageTagsCount] = useState(0);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const actual1Pages = message?.map(item => item.page_no);
        setCurrentPage(actual1Pages[0])
        setactualPageNumbers(actual1Pages);
        if (type === 2) {
            setActiveKey(['0', '3']);
        } else if (type === 3) {
            setActiveKey(['0', '4']);
        } else {
            setActiveKey(['0']);
        }
    }, [entries]);


    const hasUnsavedChanges = () => {
        const current = [...tagsOnPage].sort();
        const initial = [...tagsogOnPage].sort();
        return JSON.stringify(current) !== JSON.stringify(initial);
    };


    const handleAddTagToPage = (tag) => {
        if (!tagsOnPage.includes(tag)) {
            setTagsOnPage([...tagsOnPage, tag]);
        }
    };

    const handleremoveTagToPage = (tag) => {
        setTagsOnPage(tagsOnPage.filter(t => t !== tag));
    };
    // Trigger `handlesearchdataclick` on initial load
    useEffect(() => {
        handlesearchdataclick(currentPage);
    }, [currentPage]);

    const handlepagechangetagcheck = () => {
        if (activeKey.includes("4")) {
            const current = [...tagsOnPage].sort();
            const initial = [...tagsogOnPage].sort();
            const tagsChanged = JSON.stringify(current) !== JSON.stringify(initial);
            if (tagsChanged) {
                toast.warning("Please save or close the current tag.", {
                    autoClose: 3000,
                });

                return true;
            }
        }
        return false;
    }
    useEffect(() => {
        const current = [...tagsOnPage].sort();
        const initial = [...tagsogOnPage].sort();
        const tagsChanged = JSON.stringify(current) !== JSON.stringify(initial);
        if (tagsChanged) {
            tagenable();
        } else {
            tagadddisable();
        }
    }, [tagsOnPage]);

    // Handle page change
    const handlePageChange = (page) => {
        if (handlepagechangetagcheck()) return;
        setCurrentPage(page);
    };

    // Handle fast backward (to first available page)
    const fastBackward = () => {
        if (handlepagechangetagcheck()) return;
        setCurrentPage(actualPageNumbers[0]);
    };

    // Handle fast forward (to last available page)
    const fastForward = () => {
        if (handlepagechangetagcheck()) return;
        setCurrentPage(actualPageNumbers[actualPageNumbers.length - 1]);
    };

    const handleNextPage = () => {
        if (handlepagechangetagcheck()) return;
        const currentIndex = actualPageNumbers.indexOf(currentPage);
        if (currentIndex < actualPageNumbers.length - 1) {
            setCurrentPage(actualPageNumbers[currentIndex + 1]);
        }
    };

    const handlePreviousPage = () => {
        if (handlepagechangetagcheck()) return;
        const currentIndex = actualPageNumbers.indexOf(currentPage);
        if (currentIndex > 0) {
            setCurrentPage(actualPageNumbers[currentIndex - 1]);
        }
    };

    // Calculate page numbers to show in pagination (max 5 pages shown at once)
    const maxPagesToShow = 5;

    // Calculate the range of pages to show, centered around the current page
    let startIndex = Math.max(actualPageNumbers.indexOf(currentPage) - Math.floor(maxPagesToShow / 2), 0);
    let endIndex = Math.min(startIndex + maxPagesToShow - 1, actualPageNumbers.length - 1);

    // Get the page numbers to show based on the range
    const pageNumbersToShow = actualPageNumbers.slice(startIndex, endIndex + 1);

    //hightlighting text functionality start
    const highlightSearchTerm = (content) => {
        if (!content) return content;

        const currentData = message.find(item => item.page_no === currentPage);
        const dataPoints = currentData?.data_points || {};

        const dataPointColors = {
            title: "highlight-rect-orange",
            provider: "highlight-rect-blue",
            org: "highlight-rect-yellow",
            date: "highlight-rect-red"
        };


        // const orangeWords = Object.entries(dataPoints)
        //     .filter(([key, value]) => key !== "page_range" && Boolean(value))
        //     .map(([_, value]) => value?.trim());
        const coloredWords = Object.entries(dataPoints)
            .filter(([key, value]) => key !== "page_range" && Boolean(value))
            .map(([key, value]) => ({
                word: value.trim(),
                className: dataPointColors[key] || "highlight-rect-orange"
            }));


        const greenWords = (search_keywords || []).map(w => w.trim());

        const allWords = [
            ...greenWords.map(w => ({ word: w, className: "highlight-green" })),
            ...coloredWords
        ];
        if (allWords.length === 0) return content;

        allWords.sort((a, b) => b.word.length - a.word.length); // longer words first

        const normalizedContent = content.replace(/\s+/g, ' ').toLowerCase();

        let parts = [normalizedContent];

        allWords.forEach(({ word, className }) => {
            const tempParts = [];

            // Escape regex special characters
            const escapedWord = word.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');

            let pattern;

            // Match exact for numbers (full match only), substring match for words
            if (/^\d+$/.test(word)) {
                // Pure number
                pattern = `\\b${escapedWord}\\b`;  // match whole number only
            } else {
                // Word: allow partial matches (substring inside)
                pattern = escapedWord;
            }

            const regex = new RegExp(pattern, 'gi');

            parts.forEach((part, idx) => {
                if (typeof part !== "string") {
                    tempParts.push(part);
                } else {
                    let lastIndex = 0;
                    let match;

                    while ((match = regex.exec(part)) !== null) {
                        const start = match.index;
                        const end = regex.lastIndex;

                        if (start > lastIndex) {
                            tempParts.push(part.slice(lastIndex, start));
                        }

                        tempParts.push(
                            <span key={`${word}-${idx}-${start}`} className={className}>
                                {part.slice(start, end)}
                            </span>
                        );

                        lastIndex = end;
                    }

                    if (lastIndex < part.length) {
                        tempParts.push(part.slice(lastIndex));
                    }
                }
            });
            parts = tempParts;
        });

        return parts;
    };
    //hightlighting text functionality end


    //handle notes list based on page 
    const handleNotelist = async () => {
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}note`, {
                case_id: caseID,
                page_no: currentPage,
                get_type: "page_notes",
                mode: "listAllNote"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message?.active_notes || [];
                const responsenotecount = response.data?.message?.active_notes_count || 0;
                if (Array.isArray(responsedata)) {
                    setNoteslist(responsedata);
                    setNotesCount(responsenotecount);
                } else {
                    setNoteslist([]);
                    setNotesCount(0);
                }

            }


        } catch (error) {
            console.error("Error fetching saved search data:", error);
        }
    };


    //handle notes save functionality start
    const handleNoteAdd = async () => {
        if (!noteInput.trim()) return;
        const trimmedNote = noteInput.trim();
        if (trimmedNote.length < 5) {
            toast.warning("Please enter at least 5 characters.");
            return;
        }
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}note`, {
                case_id: caseID,
                page_no: currentPage,
                note: noteInput,
                mode: "addNote"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message || [];
                toast.success("Notes added sucessfully");
                handleNotelist();
                setNoteInput('');
                setEditNoteId(null);
            } else {
                toast.error(response.data?.message);
                setNoteInput('');
                setEditNoteId(null);
            }

        } catch (error) {
            console.error("Error fetching saved search data:", error);
        }
    };
    //handle notes save functionality end 
    
    //handle edit notes save functionality start 
    const handleEditNote = (noteId) => {
        const noteToEdit = noteslist.find(note => note.noteId === noteId);
        if (noteToEdit) {
            setNoteInput(noteToEdit.noteContent);
            setEditNoteId(noteId);
        }
    };

    const handleNoteEditSubmit = async () => {
        if (!noteInput.trim() || !editNoteId) return;
        const trimmedNote = noteInput.trim();
        if (trimmedNote.length < 5) {
            toast.warning("Please enter at least 5 characters.");
            return;
        }
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}note`, {
                case_id: caseID,
                note_id: editNoteId,
                edited_note: noteInput,
                mode: "editNote",
                edit_type: "edit"
            });

            if (response.data.status === 1) {
                toast.success("Note updated successfully.");
                setNoteInput('');
                setEditNoteId(null);
                handleNotelist();
            } else {
                toast.error("Failed to update note.");
            }

        } catch (error) {
            console.error("Error updating note:", error);
            toast.error("An error occurred while updating note.");
        }
    };
    //handle edit notes save functionality end 

    //handle delete notes  functionality start 
    const handleDeleteNote = async (noteId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This note will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const caseID = localStorage.getItem("caseID");
                    const response = await axios.post(`${API_BASE_URL}note`, {
                        case_id: caseID,
                        note_id: noteId,
                        edit_type: "delete",
                        mode: "editNote"
                    });

                    if (response.data.status === 1) {
                        toast.success("Note has been deleted successfully.");
                        setNoteInput('');
                        setEditNoteId(null);
                        handleNotelist();
                    } else {
                        setNoteInput('');
                        setEditNoteId(null);
                        toast.error("Failed to delete note.");
                    }

                } catch (error) {
                    console.error("Error delete note:", error);
                    toast.error("An error occurred while updating note.");
                }
            }
        });


    };
    //handle delete notes  functionality end 
    //tag handling start

    const handleTagAdd = async () => {
        if (!tagsInput.trim()) return;
        const trimmedTags = tagsInput.trim();
        if (trimmedTags.length < 3) {
            toast.warning("Please enter at least 3 characters.");
            return;
        }
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                tag: tagsInput,
                mode: "addTag"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message || [];
                toast.success("Tag added sucessfully");
                handleTagslist();
                setTagsInput('');
            } else {
                toast.error(response.data?.message);
                setTagsInput('');
            }

        } catch (error) {
            console.error("Error in adding tags:", error);
        }
    };

    const handleTagslist = async () => {
        //get all case tags
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                mode: "listAllTag",
                get_type: "all_tags"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message?.all_tags || [];
                const responsetagcount = response.data?.message?.all_tags_count || 0;
                if (Array.isArray(responsedata)) {
                    setCreatedTags(responsedata);
                    setTagsCount(responsetagcount);
                } else {
                    setNoteslist([]);
                    setTagsCount(0);
                }

            }


        } catch (error) {
            console.error("Error fetching saved search data:", error);
        }
        //get current page tags
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                page_no: currentPage,
                get_type: "page_tags",
                mode: "listAllTag"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message?.page_tags || [];
                const responsetagcount = response.data?.message?.page_tags_count || 0;
                const tagsOnPage = responsedata.map(tag => tag.tagId);
                const tagslabelOnPage = responsedata.map(tag => tag.tagContent);

                if (Array.isArray(responsedata)) {
                    setTagsOnPage(tagsOnPage);
                    setTagsogOnPage(tagsOnPage);
                    setTagslabelOnPage(tagslabelOnPage);

                    setcurrentpageTagsCount(responsetagcount);
                } else {
                    setTagsOnPage([]);
                    setTagsogOnPage([]);
                    setTagslabelOnPage([]);
                    setcurrentpageTagsCount(0);
                }

            }


        } catch (error) {
            console.error("Error fetching saved search data:", error);
        }
    };

    const handletagenablesubmit = async () => {

        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                page_no: currentPage,
                selected_tags: tagsOnPage,
                mode: "selectTag",

            });

            if (response.data.status === 1) {
                toast.success("Tags updated successfully.");
                setTagsInput('');
                handleTagslist();
                setTagsChanged(false);
                settagdropdownEnable(false);
            } else {
                toast.error("Failed to update tags.");
            }

        } catch (error) {
            console.error("Error updating tags:", error);
            toast.error("An error occurred while updating tags.");
        }
    };

    const noteInputRef = useRef(null);

    // Focus the input when editing starts
    useEffect(() => {
        if (editNoteId !== null && noteInputRef.current) {
            noteInputRef.current.focus();
        }
    }, [editNoteId]);

    // Track when accordion changes
    // const handleAccordionSelect = (newKey) => {

    //     if (tagsChanged && activeKey === "4" && newKey !== "4") {
    //         toast.warning("Please save or close the current tag before opening another options.", {
    //             autoClose: 3000, // optional
    //         });
    //         return;
    //     }

    //     // When opening the Tags accordion, take a snapshot
    //     if (newKey === "4") {
    //         setTagsChanged(false);
    //     }

    //     setActiveKey(newKey);
    // };
    const handleAccordionSelect = (newKey) => {
        if (!newKey) return;

        // Prevent leaving "Tags" accordion if unsaved changes exist
        // if (tagsChanged && activeKey.includes("4") && newKey !== "4") {
        //     toast.warning("Please save or close the current tag before opening another option.", {
        //         autoClose: 3000,
        //     });
        //     return;
        // }

        // // If opening the Tags accordion, reset change flag
        // if (newKey === "4" && !activeKey.includes("4")) {
        //     setTagsChanged(false);
        // }

        // Toggle accordion open/close
        setActiveKey((prevKeys) => {
            if (prevKeys.includes(newKey)) {
                return prevKeys.filter((key) => key !== newKey); // close
            } else {
                return [...prevKeys, newKey]; // open
            }
        });
    };


    // Check changes whenever tags change
    const checkTagsChanged = () => {
        if (activeKey.includes("4")) {
            const current = [...tagsOnPage].sort();
            const initial = [...tagsogOnPage].sort();
            setTagsChanged(JSON.stringify(current) !== JSON.stringify(initial));
        }
    };

    useEffect(() => {
        checkTagsChanged();
    }, [tagsOnPage, activeKey]);

    useEffect(() => {
        handleNotelist();
        handleTagslist();
        settagdropdownEnable(false);
    }, [currentPage]);



    console.log(actualPageNumbers)

    const handleaddtoreport = async () => {
        setLoading(true);
        const caseID = localStorage.getItem("caseID");
        const payload = {
            mode: "reportRequest",
            case_id: caseID,
            fields: ["Title", "Provider", "Organization", "Date", "Notes", "Page range"],
            sorting: "Title, A-Z",
            group_by: 0,
            filter_by: "Keyword",
            filter_fromDate: "",
            filter_toDate: "",
            filtered_pages: actualPageNumbers || [],
            filter_text:
                type === 1
                    ? searchterm || ""
                    : type === 2
                        ? (search_keywords ? search_keywords[0] : "")
                        : type === 3
                            ? (search_keywords ? search_keywords[0] : "")
                            : "",
            isAddToReort: 1,
            report_type: 1,
        };

        try {
            const response = await axios.post(`${API_BASE_URL}report`, payload);

            // Handle response here if needed (e.g., show success message)
            // const data = await response.json();
            // console.log("Report added successfully", data);
            if (response.status === 200) {
                toast.success("Report added sucessfully");
            } else {
                toast.error(response?.data?.message || "Failed to add the report");
            }

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleaddtotimeline = async () => {
        setLoading(true);
        const caseID = localStorage.getItem("caseID");
        const payload = {
            case_id: caseID,
            timelineSearchKeyword: searchterm || search_keywords[0] || "",
            timelineSearchKeywordPageNo: Array.isArray(actualPages) ? actualPages.join(",") : actualPages
        };

        try {
            const response = await axios.post(`${API_BASE_URL}timeline_search_repo`, payload);
            if (response.status === 200) {
                toast.success("Added to the timeline sucessfully");
            } else {
                toast.error(response?.data?.message || "Failed to add to the timeline");
            }

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div>
            <h5>{type === 1 ? "Search Result" : ((type === 2 || type === 3) ? "Filter Result" : "")}</h5>

            <div className="">
                <div className="search-results-compact">
                    <div className="search-card-sm">
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold small text-muted">
                                {
                                    type === 1
                                        ? `Search Term: ${searchterm || ""}`
                                        : type === 2
                                            ? `Filter Notes: ${search_keywords ? search_keywords[0] : ""}`
                                            : type === 3
                                                ? `Filter Tag: #${search_keywords ? search_keywords[0] : ""}`
                                                : ""
                                }
                            </span>
                        </div>
                        <div className="d-flex justify-content-between ">
                            {/* Pagination for the current searchValue */}
                            <Pagination className="mt-2 custom-pagination">
                                {/* Fast Backward button */}
                                <Pagination.First
                                    onClick={fastBackward}
                                    disabled={currentPage === actualPageNumbers[0]}
                                />
                                <Pagination.Prev
                                    onClick={handlePreviousPage}
                                    disabled={currentPage === actualPageNumbers[0]}
                                />

                                {/* Display the actual page numbers that exist in the result */}
                                {pageNumbersToShow.map((pageNum) => (
                                    <Pagination.Item
                                        key={pageNum}
                                        active={currentPage === pageNum}
                                        onClick={() => handlePageChange(pageNum)}
                                    >
                                        {pageNum}
                                    </Pagination.Item>
                                ))}

                                <Pagination.Next
                                    onClick={handleNextPage}
                                    disabled={currentPage === actualPageNumbers[actualPageNumbers.length - 1]}
                                />
                                {/* Fast Forward button */}
                                <Pagination.Last
                                    onClick={fastForward}
                                    disabled={currentPage === actualPageNumbers[actualPageNumbers.length - 1]}
                                />
                            </Pagination>
                            <div className="text-end mt-2 d-flex justify-content-end flex-wrap gap-2 align-items-center">
                                {
                                    search_report_enable === 1 ?
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleaddtoreport()}
                                            disabled={loading}
                                        >
                                            Add to the report
                                        </button>
                                        : null
                                }
                                {
                                    search_report_enable === 1 ?
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleaddtotimeline()}
                                            disabled={loading}
                                        >
                                            Add to the timeline
                                        </button>
                                        : null
                                }
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleremovesearchclick()}
                                >
                                    {
                                        type === 1
                                            ? "Remove search"
                                            : "Remove filter"
                                    }
                                </button>
                            </div>
                        </div>
                        {/* Display the content of the current page */}


                        <div className="search-content ">
                            <div className="outer-scroll-container">
                                <Accordion activeKey={activeKey} onSelect={handleAccordionSelect} className="mt-3 p-2">
                                    {/* Search Result Accordion */}
                                    {/* Summary */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header ><span className="attesta-blue"><i class="fa-solid fa-align-justify me-1"></i> Summary </span></Accordion.Header>
                                        <Accordion.Body className="small text-body">
                                            {message
                                                .find(item => item.page_no === currentPage)
                                                ?.summary}
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Data Point Accordion */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header> <span className="attesta-blue"><i class="fa-solid fa-cube me-1"></i>Data Points </span></Accordion.Header>
                                        <Accordion.Body className="small text-body">
                                            <ul className="mb-0">
                                                <li><strong>Title:</strong> {message
                                                    .find(item => item.page_no === currentPage)
                                                    ?.data_points?.title}<span className="rect-icon rect-orange"></span></li>
                                                <li><strong>Provider:</strong> {message
                                                    .find(item => item.page_no === currentPage)
                                                    ?.data_points?.provider} <span className="rect-icon rect-blue"></span></li>
                                                <li><strong>Organization:</strong> {message
                                                    .find(item => item.page_no === currentPage)
                                                    ?.data_points?.org}<span className="rect-icon rect-yellow"></span></li>
                                                <li><strong>Date:</strong> {message
                                                    .find(item => item.page_no === currentPage)
                                                    ?.data_points?.date} <span className="rect-icon rect-red"></span></li>
                                            </ul>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* page content */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header> <span className="attesta-blue"><i class="fa-solid fa-book-open me-1"></i> Page Content </span></Accordion.Header>
                                        <Accordion.Body className="small text-body search-results-scroll-container">
                                            {message.find(item => item.page_no === currentPage)?.content
                                                ? highlightSearchTerm(message.find(item => item.page_no === currentPage).content)
                                                : "No content available for this page."}
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Notes Accordion */}
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            <span className="attesta-blue">
                                                <i className="fa-solid fa-note-sticky me-1"></i> Notes
                                            </span>
                                        </Accordion.Header>
                                        <Accordion.Body className="small text-body">
                                            <p className="mb-1 fw-semibold">Your Notes ({notescount || 0}):</p>
                                            <div className="mb-2">
                                                <Form className="d-flex mb-2" onSubmit={(e) => {
                                                    e.preventDefault();
                                                    if (editNoteId) {
                                                        handleNoteEditSubmit();
                                                    } else {
                                                        handleNoteAdd();
                                                    }
                                                }}>
                                                    <Form.Control
                                                        ref={noteInputRef}
                                                        type="text"
                                                        value={noteInput}
                                                        onChange={(e) => setNoteInput(e.target.value)}
                                                        placeholder="Enter note..."
                                                        className="me-2"
                                                    />
                                                    <Button variant="primary" type="submit">
                                                        {editNoteId !== null ? 'Update' : 'Add'}
                                                    </Button>
                                                </Form>
                                            </div>
                                            <div className="mb-0 small notes-list-div">
                                                {noteslist.map((note, i) => (
                                                    <>
                                                        <div key={note?.noteId} className="p-2 border rounded mb-2 bg-light ">
                                                            <div className="d-flex  justify-content-between align-items-start">
                                                                {/* <div className="fw-semibold">{note?.noteContent || ""}</div> */}
                                                                <div
                                                                    className="fw-semibold"
                                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note?.noteContent || "") }}
                                                                ></div>

                                                                <div className="dropdown dropdown-sm">
                                                                    <button className="btn btn-link btn-sm p-0 btn-icon-black" data-bs-toggle="dropdown">
                                                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-sm">
                                                                        <li><button className="dropdown-item d-flex align-items-center" onClick={() => handleEditNote(note?.noteId)}><i className="fa fa-pen me-2"></i>Edit</button></li>
                                                                        <li><button className="dropdown-item d-flex align-items-center" onClick={() => handleDeleteNote(note?.noteId)}><i className="fa fa-trash me-2"></i> Delete</button></li>
                                                                    </ul>
                                                                </div>

                                                            </div>

                                                            <div className="small text-muted">{note?.noteCreated || ""}</div>
                                                        </div>

                                                    </>
                                                ))}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Tags Accordion */}
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            <span className="attesta-blue">
                                                <i className="fa-solid fa-tags me-1"></i> Tags
                                            </span>
                                        </Accordion.Header>
                                        <Accordion.Body className="small text-body">
                                            <p className="mb-1 fw-semibold">Tags on page ({currentpageTagsCount}):</p>
                                            <div className="mb-3 ">
                                                {tagdropdownEnable ? (
                                                    <Form className="d-flex mb-2" onSubmit={(e) => {
                                                        e.preventDefault();
                                                        handleTagAdd();
                                                    }}>
                                                        <Form.Control
                                                            type="text"
                                                            className="me-2"
                                                            value={tagsInput}
                                                            onChange={(e) => setTagsInput(e.target.value)}
                                                            placeholder="Enter tags..."

                                                        />
                                                        <Button className="btn btn-primary" type="submit" >
                                                            Add
                                                            {/* <i className="fa fa-arrow-right ms-1"></i> */}
                                                        </Button>
                                                    </Form>
                                                ) :
                                                    (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            readOnly
                                                            value={tagslabelOnPage?.join(", ")}
                                                            placeholder="Enter tags..."
                                                            onClick={() => settagdropdownEnable(true)}
                                                        />

                                                    )}

                                            </div>

                                            {tagdropdownEnable && createdTags.length > 0 && (
                                                <>
                                                    <div className="mb-2 fw-semibold small">
                                                        All your created tags ({tagscount}):
                                                    </div>

                                                    <ul className="list-unstyled small">
                                                        {createdTags.map((tag, idx) => {
                                                            const isAdded = tagsOnPage.includes(tag.tagId);
                                                            return (
                                                                <li key={tag?.tagId || idx} className="d-flex align-items-center justify-content-between mb-2">
                                                                    <div>
                                                                        <i className="fa fa-tag me-2 text-muted" />
                                                                        {tag.tagContent || ""}
                                                                    </div>
                                                                    {isAdded ? (
                                                                        <button
                                                                            className="btn btn-sm p-0 border-0 bg-transparent text-primary"
                                                                            onClick={() => handleremoveTagToPage(tag.tagId)}
                                                                        >
                                                                            <i className="fa fa-check text-muted" />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="btn btn-sm p-0 border-0 bg-transparent text-primary"
                                                                            onClick={() => handleAddTagToPage(tag.tagId)}
                                                                        >
                                                                            <i className="fa fa-plus text-muted" />
                                                                        </button>
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>

                                                    <button className="btn btn-sm btn-outline-primary w-100 fw-semibold" onClick={() => handletagenablesubmit()}>
                                                        Save and Close
                                                    </button>
                                                </>)}

                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default SearchResultTable;